import React from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { useHistory } from 'react-router-dom';
import {
    setPreferredCallCanvasSize,
    updateLayoutColumns,
} from 'flow/actions/app-actions';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { routes } from 'flow/types/routes';
import { addUserPhoneLogEntry } from 'flow/utils/browser-utils';
import { generatePath } from 'flow/utils/router-utils';
import { DisplayMode } from 'flow/utils/rtc-utils';

import Icon from '../ui-components/Icon';
import IconButton from '../ui-components/IconButton';
import { setActiveMeetingViewAction } from 'flow/actions/meeting-actions';

const CallHeader = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    const onClickMinimise = () => {
        addUserPhoneLogEntry('Comm canvas -> minimize panel clicked');
        dispatch(setPreferredCallCanvasSize(DisplayMode.MINIMIZED.key));
        dispatch(setActiveMeetingViewAction(DisplayMode.MINIMIZED.key));
        dispatch(updateLayoutColumns());
    };

    const onClickSettings = () => {
        addUserPhoneLogEntry('Comm canvas -> settings clicked');
        history.push(
            generatePath(routes['settings.softphone'], {
                extensionKey: ownExtensionKey,
            }),
        );
    };

    return (
        <div className="my-4 flex w-full items-center justify-end gap-2 pe-3">
            <IconButton
                aria-label={i18next.t('Call.Canvas.Title.Minimize')}
                className="size-8 hover:bg-gray-600"
                onClick={onClickMinimise}
            >
                <Icon iconKey="bottombar_inverted" />
            </IconButton>

            <IconButton
                aria-label={i18next.t('settings')}
                className="size-8 text-white hover:bg-gray-600"
                onClick={onClickSettings}
            >
                <Icon iconKey="general" />
            </IconButton>
        </div>
    );
};

export default CallHeader;
